import { NO_STATUS, REQUESTED, APPROVED, REJECTED } from 'shared/receivers/receivers-statuses-id';

export const statusRules: any = [
  {
    from: null,
    to: [REQUESTED], // 1
    color: 'yellow',
    direction: 'up',
  }, {
    from: null,
    to: [APPROVED], // 2
    color: 'green',
    direction: 'up',
  }, {
    from: null,
    to: [REJECTED], // 3
    color: 'red',
    direction: 'down',
  }];
